<template>
  <div class="popUpWrap">
    <section class="popup dark assessment" :style="popupStyle">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon" :class="{[icon]: true}"></div>
        <div class="textArea" :class="{ flex: dialogStore.options.props.isAllComplete }">
          <h5 v-html="convertToNextLine(title)" />
          <p v-html="convertToNextLine(content)"></p>
        </div>
        <div
            v-if="(!dialogStore.options.props.isAllComplete && dialogStore.options.props.isAllComplete !== undefined)"
            class="boxArea"
            style="padding: 24px;"
        >
          <ul class="chapterSub scrollY">
            <LearningAssessmentSetMenuItem
                v-if="!assessmentStore.isContest"
                v-for="(assessmentSet, index) in setList"
                :key="index"
                :index="index"
                :assessment-set="assessmentSet"
            />

            <li v-else>
              <div class="titleArea">
                <LazyLearningHeaderProgressDetailIItem
                    :learning-type="LearningType.Contest"
                    :task-list="assessmentStore.contestList"
                />
                <LazyLearningTaskMenu :task-list="assessmentStore.contestList"/>
              </div>
            </li>
          </ul>
        </div>
        <div class="btnArea">
          <button v-if="dialogStore.options.close && closeTitle" class="cancel" @click.stop="onClickClose" >{{ closeTitle }}</button>
          <LazySafetyRequestButton tag="button" :safety-click="onClickConfirm" >{{ confirmTitle }}</LazySafetyRequestButton>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {computed, convertToNextLine, useI18n} from '#imports';
import LearningConfirmPopupType from '~/components/Common/Dialog/dialog/LearningConfirmPopup/LearningConfirmPopupType';
import {
  ProSkillAssureAssessmentSetModel
} from '~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentSetModel';
import {useLearningAssessmentStore} from '~/store/learning/assessment/learningAssessmentStore';
import {LazyLearningTaskMenu} from '#components';
import {LearningType} from '~/store/learning/model/LearningType';

const { t } = useI18n();

const dialogStore = useDialogStore();
const assessmentStore = useLearningAssessmentStore();

const isConnectFail = computed(() =>
  dialogStore.options.props.type === LearningConfirmPopupType.CONNECT_FAIL
);
const isFrontLearningStartFail = computed(() =>
    dialogStore.options.props.type === LearningConfirmPopupType.FRONT_LEARNING_START_FAIL
)

const icon = computed(() => {
  if(isConnectFail.value || isFrontLearningStartFail.value) {
    return "fail"
  } else {
    return dialogStore.options.props.icon
  }
})

const title = computed(() => {
  if(isConnectFail.value) {
    return t("learning-exercise-refresh-page")
  } else if(isFrontLearningStartFail.value) {
    return t("learning-exercise-request-fail", {email: "support@codepresso.io"})
  } else {
    return dialogStore.options.props.title
  }
})

const content = computed(() => {
  if(isConnectFail.value) {
    return t("learning-exercise-request-fail", {email: "support@codepresso.io"})
  } else if(isFrontLearningStartFail.value) {
    return t("learning-front-exercise-download-fail")
  } else {
    return dialogStore.options.props.content;
  }
})

const popupStyle = computed(() => {
  if(dialogStore.options.props.isAllComplete !== undefined) return { 'max-width': '640px'}
  else return {};
})

const confirmTitle = computed(() => {
  return dialogStore.options.confirm?.title ?? t("common-ok")
})

const closeTitle = computed(() => {
  return dialogStore.options.close!.title
})

const setList = computed(() => {
  return assessmentStore.proSkillAssure.assessment.setList as ProSkillAssureAssessmentSetModel[];
})

const onClickClose = () => {
  dialogStore.options.close?.event()
  dialogStore.close()
}

const onClickConfirm = (): Promise<void> => {
  return new Promise(resolve => {
    dialogStore.options.confirm?.event()
    resolve();
    dialogStore.close();
  })
}
</script>

